import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const FireHydrantIntegration = React.lazy(() => import("./FireHydrantIntegration"));

interface FireHydrantIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function FireHydrantIntegrationLazy(props: FireHydrantIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <FireHydrantIntegration {...props} />
    </Suspense>
  );
}
